import { Calendar } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import {
  areDatesSameIgnoringTime,
  ICalendarCommon,
} from '../../../utils/calendarUtility';
import { displayCenter } from '../../../utils/styleobjects';
import { HoverWrapper } from '../hover-wrapper/HoverWrapper';
import './CalendarMobile.scss';

export const CalendarMobile: React.FC<ICalendarCommon> = ({
  selectedDays,
  onDateClickHandler,
  onMonthChange,
  onEdit,
  onDelete,
  disabledDates = [],
  disabledDays = [],
}) => {
  const isSelectedDate = (date: Dayjs) => {
    const day = date.date();
    const month = date.month();
    const year = date.year();
    const requiredDate = new Date(year, month, day);

    const isSelected = selectedDays.find(({ startdate, lastdate }) => {
      const endDate = lastdate || startdate; // If lastdate is not provided, consider it same as startdate
      return requiredDate >= startdate && requiredDate <= endDate;
    });

    return isSelected;
  };

  /**
   *  disable block date
   */
  const isInDisabledDates = (current: Dayjs) => {
    return disabledDates.some(disabledDate =>
      areDatesSameIgnoringTime(disabledDate, current.toDate()),
    );
  };

  /**
   * disable day in disabledDays
   */
  const disableDays = (current: Dayjs) => {
    return disabledDays.includes(current.day()) || isInDisabledDates(current);
  };

  const dateCellRender = (date: Dayjs) => {
    const isSelected = isSelectedDate(date);
    const isLastDateOfEvent =
      isSelected &&
      isSelected?.lastdate?.getDate() == date.date() &&
      isSelected?.lastdate?.getMonth() == date.month();
    const Icon = isSelected?.Icon;
    return (
      <div
        key={date.date()}
        onClick={() => {
          if (isSelected) return;
          onDateClickHandler?.(date.toDate());
        }}
        style={{
          ...displayCenter,
          backgroundColor: isSelected ? isSelected.color : undefined,
          opacity: isLastDateOfEvent || !isSelected ? 1 : 0.5,
          height: '100%',
          width: '100%',
        }}
      >
        {isSelected && Icon && isLastDateOfEvent ? (
          <HoverWrapper
            Icon={isSelected.Icon}
            isLastDate={date.day() == 6}
            onDelete={
              onDelete && !isSelected?.disableDelete
                ? () => {
                    onDelete?.(isSelected);
                  }
                : undefined
            }
            onEdit={
              onEdit
                ? () => {
                    onEdit?.(isSelected);
                  }
                : undefined
            }
          />
        ) : (
          date.date()
        )}
      </div>
    );
  };

  return (
    <div>
      <Calendar
        className='calendar-mobile'
        mode='month'
        fullCellRender={dateCellRender}
        validRange={[dayjs(), dayjs().add(10, 'year')]}
        onPanelChange={date => {
          const year = date.year();

          const month = date.month();
          console.log('Year:', year, 'Month:', month);
          onMonthChange?.(year, month);
        }}
        disabledDate={disableDays}
        fullscreen={false} // Makes it mobile-friendly
      />
    </div>
  );
};
